import {
  getIndividualRating,
  getNoAndHoursOfMeetings,
  getTags,
  getTeamListForMeetingNotes,
  slackChannelsList,
  slackUsersList,
} from "api";
import { useQuery } from "react-query";
import { useUser } from "stores/useUser";
import { useEffect } from "react";
import teamStore from "stores/useTeamStore";

const usePrefetch = ({ source }) => {
  const {
    user: {
      email,
      uid,
      subscription: { organization_id, plan, department },
    },
    setTags,
    setSlackChannels,
    setSlackUsers,
  } = useUser();
  const { team, setTeam } = teamStore.getState();

  const enabled = source !== "extension";
  const getMeetingsTags = async () => {
    const response = await getTags(uid, plan, organization_id, department);

    response?.data &&
      setTags(
        response?.data.map((tagName) => {
          return { tag: tagName };
        })
      );
  };

  // const getSlackChannels = async () => {
  //   const response = await slackChannelsList();
  //   response?.data && setSlackChannels(response?.data);
  // };

  // const getSlackUsers = async () => {
  //   const response = await slackUsersList();
  //   response?.data && setSlackUsers(response?.data);
  // };

  useEffect(() => {
    if (uid) {
      getMeetingsTags();
      // getSlackChannels();
      // getSlackUsers();
    }
  }, [uid]);
  //* fetch team from organization
  useEffect(() => {
    const getTeam = async () => {
      const { data } = await getTeamListForMeetingNotes(email);
      setTeam(
        data
          ?.map((x) => {
            const currentEmail = x.emails.filter((x) => x.type === "work")[0]
              ?.data;
            return (
              currentEmail && {
                id: currentEmail,
                value: x.first_name + " " + x.last_name,
                uid: x.uid,
                finch_id: x.finch_id,
              }
            );
          })
          .filter((x) => x)
      );
    };
    if (team === null) {
      getTeam();
    }
  }, [email, team, setTeam]);

  useQuery({
    queryKey: ["hours", "attendee", email],
    queryFn: () => getNoAndHoursOfMeetings("attendee", email),
    staleTime: 300000,
    enabled,
  });

  useQuery({
    queryKey: ["Effectiveness Compare", email, "attendee"],
    queryFn: () => getIndividualRating(email),
    staleTime: 5 * (60 * 1000), //5 minutes
    enabled,
  });

  useQuery({
    queryKey: ["hours", "organizer", email],
    queryFn: () => getNoAndHoursOfMeetings("organizer", email),
    staleTime: 300000,
    enabled,
  });

  useQuery({
    queryKey: ["Effectiveness Compare", email, "organizer"],
    queryFn: () => getIndividualRating(email),
    staleTime: 5 * (60 * 1000), //5 minutes
    enabled,
  });

  return null;
};

export default usePrefetch;
